import { deleteDoc, doc, getDoc, setDoc, type Firestore } from "firebase/firestore";
import type { SaveAdapter } from "@yjsgames/save";

/**
 * Firestore 클라우드 SaveAdapter — 문서 경로 `users/{uid}/saves/{key}`.
 * payload(JSON string)를 그대로 문서 필드로 저장하고 `updatedAtUtcMs`를 함께 기록한다.
 * `WriteBehindSaveAdapter`의 cloud 계층으로 주입돼 n분 주기 batch flush로만 쓰기가 일어난다.
 *
 * 보안 규칙(Firebase 콘솔 수동 적용):
 *   match /users/{uid}/{document=**} {
 *     allow read, write: if request.auth != null && request.auth.uid == uid;
 *   }
 */
export class FirestoreSaveAdapter implements SaveAdapter {
  constructor(
    private readonly db: Firestore,
    private readonly uid: string,
  ) {}

  private ref(key: string) {
    return doc(this.db, "users", this.uid, "saves", key);
  }

  async save(key: string, payload: string): Promise<void> {
    await setDoc(this.ref(key), { payload, updatedAtUtcMs: Date.now() });
  }

  async load(key: string): Promise<string | null> {
    const snap = await getDoc(this.ref(key));
    if (!snap.exists()) return null;
    const value = (snap.data() as Record<string, unknown>)["payload"];
    return typeof value === "string" ? value : null;
  }

  async delete(key: string): Promise<void> {
    await deleteDoc(this.ref(key));
  }
}
